export default __webpack_public_path__ + "static/media/solar.829e2ebd.svg";